export default __webpack_public_path__ + "static/media/yogurtparfait@3x.fbe79d0d.jpg";